import * as _ from 'lodash';
import { Component, Inject, OnInit, OnDestroy, isDevMode } from '@angular/core';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import { ActiveSubscription, GrandStreamProvisioningService } from '@wephone-app-phone/services/phone-provisioning/grandstream/grandstream.service';
import { SipPhoneService } from '@wephone-common/service/sipphone.service';
import { MessageService } from '@wephone-utils';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ipphone-provisioning-modal',
  templateUrl: 'ipphone-provisioning.html',
  styleUrls: ['./ipphone-provisioning.scss']
})
export class IPPhoneProvisioningModal extends DialogComponentBase implements OnInit, OnDestroy {
  PERIODICAL_UPDATE = true;

  constructor(
    dialogRef: MatDialogRef<IPPhoneProvisioningModal>,
    private grandStreamProvisioningService: GrandStreamProvisioningService,
    // private sipphoneService: SipPhoneService,
    // private messageService: MessageService
  ) {
    super(dialogRef);

  }

  pendingPhoneList() {
    return this.grandStreamProvisioningService.pendingPhoneList();
  }

  async configurePhone(phone: ActiveSubscription) {
    //const assignedSipPhone = await this.sipphoneService.selectSipPhone('Choose a SIP account to assign to the phone');
    //const url = await this.sipphoneService.validatePhoneConfigRequest(assignedSipPhone, 'grandstream_grp26xx');
    const url = 'http://192.168.90.100:8081/grandstream-config.xml';

    if (url) {
      this.grandStreamProvisioningService.sendPhoneConfiguration(phone, url);
    }
  }
}
